export const PAGE_OVERVIEW = '/content/overview/';
export const PAGE_DETAIL = '/content/detail/';
export const PAGE_INSIGHTS = '/content/insights/';
export const PAGE_IMPROVEMENTS = '/content/faq/mint/';
export const PAGE_HELP = '/content/faq/help/';
